










import Vue from 'vue';

export default Vue.extend({
  name: 'SystemMessage',
  props: {
    message: String,
    flip: Boolean
  }
});
